<div class="sign-up-container">
    <div class="banner-container">
        <img src="assets/images/backgrounds/cz-poster.jpg" />
    </div>
    <div class="form-container p-l-30 p-r-30">
        <form [formGroup]="formGroup.group">
            <div class="logo">
                <img src="assets/images/logo/logo-dark-bit.svg" />
                <div><b>CustomerZone</b></div>
            </div>
            <div class="info m-t-20">Forgot Your Password?</div>

            <div class="password-reset-info m-t-10">Enter your email address below. We'll send you a link to reset your password.</div>

            <div class="d-flex flex-column m-t-30">
                <div class="d-flex flex-direction-column form-control">
                    <label>Email Address</label>
                    <mat-form-field
                        appearance="outline"
                        class="input-form-field w-50-percent m-t-10"
                    >
                        <input
                            formControlName="email"
                            matInput
                            maxlength="255"
                            placeholder="Enter your email"
                            required
                            type="email"
                        />
                        <mat-error *ngIf="EmailControl?.errors">
                            {{ formGroup.getReadableError('email') }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="d-flex justify-space-between w-50-percent">
                <button
                    (click)="router.navigate(['/login'])"
                    class="m-t-20"
                    color="primary"
                    mat-button
                >
                    BACK TO LOGIN
                </button>
                <button
                    (click)="requestPasswordReset()"
                    *appShowSpinner="isLoading"
                    [disabled]="!formGroup.group.valid"
                    class="m-t-20"
                    color="primary"
                    mat-stroked-button
                >
                    SEND RESET LINK
                </button>
            </div>
        </form>
    </div>
</div>
